<template>
  <div class="apps">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
      
      <!-- Management Section-->
      <div v-if="section == 'management' && sections.includes('management')" class="p-2" style="margin-top: 92px;">
        <Management></Management>
      </div>

      <!-- Monitor Section-->
      <div v-if="section == 'monitor' && sections.includes('monitor')" class="p-2" style="margin-top: 92px;">
        <Monitor></Monitor>
      </div>


    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'
import Monitor from '@/components/apps-components/panoptico/Monitor.vue'
import Management from '@/components/apps-components/panoptico/Management.vue'

import axios from "axios";

export default {
  name: 'Panoptico',
  components: {
    HeaderBar3,
    Monitor,
    Management
  },
  data(){
    return {
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'panoptico',
      hbref: 'hb_panoptico',
      section: null,
      preferred: 'monitor',
      sections: [],
      apps: {},
      // Sections key.
      compkeys: {
        monitor: 0,
        management: 0
      }
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    //localStorage.setItem('vrfaware_app','Panoptico')
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>
